// Lightweight stream cards: no ThreadInfo strip under stream titles, and no "latest 3"
// filler preview replies — thin reply rows render only when they carry a signal (new
// since the user's last visit, or search matches). The shared helper keeps the render
// paths and stream height estimator aligned so estimates always match what mounts.
export function lightweightThreadInStreamEnabled(): boolean {
    return true
}

export function lightweightStreamCardEnabled(inStream: unknown): boolean {
    return !!inStream && lightweightThreadInStreamEnabled()
}
